import React from 'react';
import {Stack, HStack, useTheme, StyleProps} from '@chakra-ui/react';
import {TextA14, TextG10} from '../typography';
import SwiperSlider, {SwiperSliderProps} from '../SwiperSlider';

interface ItemCarosuelProps<T> extends StyleProps {
  id?: string;
  highlightId?: string;
  title?: string;
  subtitle?: string;
  TitleComponent?: React.ElementType;
  SubtitleComponent?: React.ElementType;
  topRightItem?: any;
  swiperProps?: SwiperSliderProps<T>;
  titleUpperCase?: boolean;
}

function ItemCarousel<T>({
  id,
  highlightId,
  title,
  subtitle,
  TitleComponent = TextA14,
  SubtitleComponent = TextG10,
  topRightItem,
  swiperProps,
  titleUpperCase = true,
  ...rest
}: ItemCarosuelProps<T>) {
  const theme = useTheme();

  if (!swiperProps?.items || swiperProps.items.length === 0) return null;

  return (
    <Stack
      id={highlightId}
      pos="relative"
      gap={title || topRightItem ? '.1rem' : 0}
      textAlign="left"
      width="100%"
      {...(rest as StyleProps)}>
      {topRightItem && (
        <HStack pos="absolute" top={2} right={3}>
          {topRightItem}
        </HStack>
      )}
      {}
      <Stack>
        {title && (
          <TitleComponent id={id} fontWeight="bold">
            {titleUpperCase ? title.toLocaleUpperCase() : title}
          </TitleComponent>
        )}
        {subtitle && (
          <SubtitleComponent mt="0px !important" color={theme.colors.grey}>
            {subtitle}
          </SubtitleComponent>
        )}
      </Stack>
      <SwiperSlider {...(swiperProps as SwiperSliderProps<T>)} />
    </Stack>
  );
}

export default ItemCarousel;
